import React, { useState } from 'react';
import Table from 'react-bootstrap/esm/Table';
import "./ChemoOrder.scss";
import Multiselect from "multiselect-react-dropdown";

function SideEffects({ allMedicinesSideEffect, values, dropdown, readOnly, onValueChange, index, appointmentDetails, order }: any) {

  console.log(values, "values of premedication info");
  const [dropdownSideEffect, setDropdownSideEffect] = useState<any>([]);

  function getNewSideEffect(medName: any) {
    const value: any = allMedicinesSideEffect?.find((each: any) => each?.genericName === medName)

    const options = value?.sideEffects?.length > 0 ?
      value?.sideEffects?.map((e: any) => {
        return e;
      }) : []

    return options
  }


  const newPreMedication = values[index];



  return (
    <div style={{ marginTop: '20px' }}>
      <Table id="tablePreview" bordered hover >
        <thead style={{ backgroundColor: "#E1E3EF" }}>
          <tr>

            <th>Medicine Name</th>
            <th>SideEffects</th>

          </tr>
        </thead>
        {/* <tbody>
          {values?.map((val: any, i: any) => {
            return <>
              {val?.medicines?.map((item: any, j: any) => {
                if (item?.route) {
                  return (
                    <tr className="procedure-data">
                      <td>{item?.medicineName}</td>
                      <td>
                        <Multiselect
                          isObject={false}
                          options={getNewSideEffect(item?.medicineName)}
                          selectedValues={
                            item?.selectedSideEffects
                          }

                          onSelect={(data) => {
                            onValueChange(data, i, j);
                          }}
                          disable={readOnly}
                        ></Multiselect>
                      </td>
                    </tr>
                  )
                }
              })}
            </>
          })}
        </tbody> */}
        {/* SideEffects updated code */}
        <tbody>

          {newPreMedication?.medicines?.map((item: any, j: any) => {
            if (item?.sideEffectCheck) {
              return (
                <tr className={`procedure-data  ${(
                  newPreMedication?.isCancelled ||
                  readOnly ||
                  appointmentDetails?.appointmentType === "OPD" ||
                  (appointmentDetails?.appointmentType === "IPD" && !order?.isActive && !order?.isCompleted)
                ) ? "disabledDiv" : ""}`}>
                  <td>{item?.medicineName}</td>
                  <td>
                    <Multiselect
                      isObject={false}
                      options={getNewSideEffect(item?.medicineName)}
                      selectedValues={
                        item?.selectedSideEffects
                      }
                      onSelect={(data) => {
                        onValueChange(data, index, j);
                      }}
                      disable={readOnly}
                    ></Multiselect>
                  </td>
                </tr>
              )
            }
          })}


        </tbody>
      </Table>
    </div>
  )
}

export default SideEffects